import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AutoplayCarousel from './components/AutoplayCarousel/AutoplayCarousel';
import THC from './components/Global/BannerCard/T&HC/THC';
import Carousel1 from './components/Carousel/Carousel1';
import EngineeringShowcase from './components/EngineeringShowcase/EngineeringShowCase';
import Footer from './components/Footer/Footer';
import MakeTheShift from './components/MakeTheShift/MakeTheShift';
import Navbar1 from './components/Navbar/Navbar1';
import Partner from './components/Partner/Partner';
import PeopleSection from './components/PeopleSection/PeopleSection';
import Spotlight from './components/Spolight/Spotlight';
import Sustainability from './components/Sustainability/Sustainability';

// What We Serve
import AerospaceDefense from './Pages/Home/WhatWeServe/AerospaceDefense';
import RailTransportation from './Pages/Home/WhatWeServe/RailTransportation';
import AutomotiveMobility from './Pages/Home/WhatWeServe/AutomotiveMobility';
import Mining from './Pages/Home/WhatWeServe/Mining';
import Energy from './Pages/Home/WhatWeServe/Energy';
import UtilitiesSpatialIntelligence from './Pages/Home/WhatWeServe/UtilitiesSpatialIntelligence';
import Communications from './Pages/Home/WhatWeServe/Communications';
import HealthCareLifeSciences from './Pages/Home/WhatWeServe/HealthCareLifeSciences';
import WhoWeServe from './Pages/Home/WhatWeServe/WhoWeServe';

// What We Do
import Services from './Pages/Home/WhatWeDo/Services';
import Plant from './Pages/Home/WhatWeDo/Plant';
import Network from './Pages/Home/WhatWeDo/Network';

// Investors
import Investors from './Pages/Home/Investors/Investors';

// Innovation
import Innovation from './Pages/Home/Innovation/Innovation';



//Who we are
import AboutUs1 from './Pages/Home/Who We Are/AboutUs1';

// Careers
import Careers from './Pages/Home/Careers/Careers';
import CurrentOpportunities from './Pages/Home/Careers/CurrentOpportunities';
import JobDetails from './Pages/Home/Careers/JobDetails';
import JobList from './Pages/Home/Careers/JobList';

// Contact Us
import ContactUs from './Pages/Home/ContactUs/ContactUs';
import NotFound from './Pages/NotFound';
import SearchResults from './components/Navbar/SearchResults';

// Legal
import PrivacyPolicy from './Pages/Legal/PrivacyPolicy';
import Disclaimer from './Pages/Legal/Disclaimer';
import Cookies from './Pages/Legal/Cookies';
import LegalInformation from './Pages/Legal/LegalInformation';







function App() {
  return (
    <Router>
      <Navbar1 />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Carousel1 />
              <EngineeringShowcase />
              <AutoplayCarousel />
              <THC />
              <Partner />
              <PeopleSection />
              <Spotlight />
              <MakeTheShift />
            </>
          }
        />

        {/* What We Serve */}
        <Route path="/our-expertise" element={<AerospaceDefense />} />
        <Route path="/rail-transportation" element={<RailTransportation />} />
        <Route path="/automotive-mobility" element={<AutomotiveMobility />} />
        <Route path="/mining" element={<Mining />} />
        <Route path="/energy" element={<Energy />} />
        <Route path="/utilities" element={<UtilitiesSpatialIntelligence />} />
        <Route path="/communications" element={<Communications />} />
        <Route path="/healthcare" element={<HealthCareLifeSciences />} />
        <Route path="/who-we-serve" element={<WhoWeServe />} />

        {/* What We Do */}
        <Route path="/services" element={<Services />} />
        <Route path="/plant" element={<Plant />} />
        <Route path="/network" element={<Network />} />

        {/* Investors */}
        <Route path="/investors" element={<Investors />} />

        {/* Innovation */}
        <Route path="/innovation" element={<Innovation />} />


        {/* Careers */}
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/open-positions"element={<CurrentOpportunities /> }/>
        <Route path="/careers/job-details/:id" element={<JobDetails />} />
        <Route path="/joblist" element={<JobList />} />
        {/* Who We are */}
        <Route path="/about" element={<AboutUs1 />} />

        {/* Contact Us */}
        <Route path="/contact" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/search" element={<SearchResults />} />
        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/legal-information" element={<LegalInformation />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
